// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/News/News.sass
// module id = 437
// module chunks = 0